/* eslint-disable max-len */
import React from 'react';
import './style.scss';
import { Link } from 'gatsby';
import VisibilitySensor from 'react-visibility-sensor';

const StockistFinderFeature = () => {
    const [isVisible, setIsVisible] = React.useState(false);
    return (
        <div
            className="stockist-finder-feature-container"
        >
            <div className="container">


                <VisibilitySensor
                    delayedCall
                    active={!isVisible}
                    onChange={visible => !isVisible && setIsVisible(visible)}
                >
                    <>
                        <div className={`stockist-finder-feature-container__image ${isVisible ? 'slide-in-left' : ''}`}>
                            <img
                                src="https://cdn.pixabay.com/photo/2018/01/31/05/43/web-3120321_1280.png"
                                alt="DR Watson Stockist Finder"
                            />
                        </div>

                        <div className={`stockist-finder-feature-container__text ${isVisible ? 'slide-in-right' : ''}`}>
                            <div className="title is-size-5-touch is-size-4-desktop is-spaced">
                               Find your nearest stockist!
                            </div>
                            <div className="subtitle is-size-6-touch is-size-5-desktop">
                               DR WATSON CBD is becoming more and more accessible - want to try it? Use our stockist
                               finder tool to locate a store near you if you prefer buying in person.
                            </div>

                            <Link className="button is-large is-theme-success has-text-weight-semibold has-text-white" to="/stockists">View Stockist Finder</Link>
                        </div>
                    </>
                </VisibilitySensor>
            </div>
        </div>
    );
};


export default StockistFinderFeature;
